/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useEffect, useState } from 'react';
import * as S from './ItemSpecVenus.styles';
import {
  ChannelPage,
  IChannelPageWidgetProps,
} from '../channel-page-widget-react';
import {
  IconListComp,
  MediaListComp,
  IIconListProps,
  ISectionListProps,
  Paginate,
  IPaginateProps,
  IAccordionProps,
  AccordionComp,
  accordionItems,
  MultiColList,
  IMultiColListProps,
  CarouselSection,
  ICarouselItems,
  ICarouselSectionProps,
  VideoViewerModal,
  ImageModal,
  PdfViewerModal,
  QRModal,
  AudioViewerModal,
  MediaCarousel,
  IMediaCarouselProps,
  IMediaCarouselItems,
  multiColData,
} from './components';
import {
  AboutPage,
  IAboutPageProps,
} from '@vlinder-web/about-page-widget-react';
import {
  TimelineMercury,
  ITimelineItemProps,
} from '@vlinder-web/timeline-venus-widget-react';
import { ProfileComp } from '../channel-page-widget-react/components';

interface IIconListProps {
  listItems?: {
    id: string;
    listImg?: string;
    title?: string | string[];
    meta?: string | string[];
    metaLogo?: string;
  }[];
}

export interface IItemSpecVenusWidgetProps {
  whoAmI?: string;
  profileData?: IChannelPageWidgetProps;
  submitData?: IChannelPageWidgetProps;
  itemSpecData: {
    type:
      | 'about'
      | 'accordion'
      | 'multi-col-list'
      | 'carousel'
      | 'media-carousel'
      | 'icon-sections'
      | 'media-sections'
      | 'timeline';
    data:
      | IAboutPageProps
      | accordionItems[]
      | multiColData[]
      | ICarouselItems[]
      | IMediaCarouselItems[]
      | IIconListProps[]
      | ISectionListProps[]
      | ITimelineItemProps[];
    // [key?: string]: any;
  }[];
  isLoading: boolean;
  metaSymbol?: string;
  titleSymbol?: string;
  onListClick?(data?: any): void;
  timelineCardClick?(id: string): void;
  actionMenu?: {
    key: string;
    label: string;
  }[];
  onActionClick?(key: string, listId: string): void;
  paginationProps: IPaginateProps;
  onPageChange?(event: any): void;
  onButtonClick?(item?: any): void;
  onSubmit?(): void;
  onVerify?(): void;
  onTerminate?(): void;
  onDownload?(): void;
  onViewAllClick?(key: string): void;
  iscomment?: any;
  showcomment?: any;
  closecomment?(): void;
  setShowComment?: any;
  status?: any;
}

export const ItemSpecVenusWidget = (props: IItemSpecVenusWidgetProps) => {
  const [activeNav, setActiveNav] = useState<string>(
    props?.profileData?.activeKey
  );
  const {
    type,
    paginationProps,
    profileData,
    submitData,
    isLoading,
    onButtonClick,
    actionMenu,
    itemSpecData,
    onSubmit,
    onTerminate,
    onDownload,
    iscomment,
    showcomment,
    closecomment,
    onVerify,
    setShowComment,
    status,
  } = props;
  console.log('daataa', itemSpecData);
  const [imageModalObj, setImageModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });
  const [pdfModalObj, setPdfModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });

  const [videoModalObj, setVideoModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });

  const [audioModalObj, setAudioModalObj] = useState<{
    enableVisibility: boolean;
    src: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    src: undefined,
    title: undefined,
  });

  const [mapModalObj, setMapModalObj] = useState<{
    enableVisibility: boolean;
    accessToken: string | undefined;
    markers: any | undefined;
    center: any | undefined;
  }>({
    enableVisibility: false,
    accessToken: undefined,
    markers: undefined,
    center: undefined,
  });

  const [QRModalObj, setQRModalObj] = useState<{
    enableVisibility: boolean;
    qrValue: string | undefined;
    title: string | undefined;
  }>({
    enableVisibility: false,
    qrValue: undefined,
    title: undefined,
  });
  console.log(activeNav, props?.profileData?.activeKey);
  const _onCarouselImageClick = async (item: any) => {
    if ((item?.type === 'img' || item?.type?.includes('image')) && item?.src) {
      setImageModalObj({
        ...imageModalObj,
        src: item.src,
        title: item.title,
        enableVisibility: true,
      });
    }
    if ((item?.type === 'pdf' || item?.type?.includes('pdf')) && item?.src) {
      // await WebBrowser.openBrowserAsync(item.src);
      setPdfModalObj({
        ...pdfModalObj,
        src: item?.src,
        title: item.title,
        enableVisibility: true,
      });
    }
    if (
      (item?.type === 'video' || item?.type?.includes('video')) &&
      item?.src
    ) {
      setVideoModalObj({
        ...videoModalObj,
        src: item.src,
        title: item.title,
        enableVisibility: true,
      });
    }
    if (
      (item?.type === 'audio' || item?.type?.includes('audio')) &&
      item?.src
    ) {
      setAudioModalObj({
        ...audioModalObj,
        src: item.src,
        title: item.title,
        enableVisibility: true,
      });
    }
    if (item?.type === 'map' && item?.markers && item?.accessToken) {
      setMapModalObj({
        ...mapModalObj,
        accessToken: item.accessToken,
        markers: item.markers,
        center: item.center,
        enableVisibility: true,
      });
    }

    if (item?.type === 'qr') {
      setQRModalObj({
        ...QRModalObj,
        enableVisibility: true,
        qrValue: item?.src,
      });
    }
  };
  const _onDeny = () => {
    setImageModalObj({
      ...imageModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };

  const onVideoClose = () => {
    setVideoModalObj({
      ...videoModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };

  const onAudioClose = () => {
    setAudioModalObj({
      ...audioModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };

  const onPdfClose = () => {
    setPdfModalObj({
      ...pdfModalObj,
      src: undefined,
      title: undefined,
      enableVisibility: false,
    });
  };

  const onQrClose = () => {
    setQRModalObj({
      ...QRModalObj,
      enableVisibility: false,
      qrValue: undefined,
    });
  };

  useEffect(() => {
    setActiveNav(props?.profileData?.activeKey);
  }, [props?.profileData?.activeKey]);

  const _renderBody = () => {
    let _data: any = {};
    if (Array.isArray(itemSpecData) && itemSpecData?.length > 0) {
      _data = itemSpecData?.find((element) => element?.key === activeNav);
    }

    console.log('find->', _data, activeNav, props?.profileData?.activeKey);
    console.log('renderbosy->', itemSpecData);

    switch (_data?.type) {
      case 'about':
        return <AboutPage {..._data?.data} />;
      case 'accordion':
        return (
          <AccordionComp
            {..._data}
            _onCarouselImageClick={_onCarouselImageClick}
            onButtonClick={onButtonClick}
          />
        );
      case 'multi-col-list':
        return <MultiColList {..._data} />;
      case 'carousel':
        return (
          <CarouselSection
            {..._data}
            onCarouselImageClick={_onCarouselImageClick}
          />
        );
      case 'icon-sections':
        return (
          <IconListComp
            {..._data}
            isLoading={isLoading}
            actionMenu={actionMenu}
          />
        );
      case 'media-sections':
        return (
          <MediaListComp
            {..._data}
            {...props}
            isLoading={isLoading}
            actionMenu={actionMenu}
          />
        );
      case 'media-carousel':
        return (
          <MediaCarousel
            {..._data}
            onCarouselImageClick={_onCarouselImageClick}
          />
        );
      case 'timeline':
        return <TimelineMercury items={_data?.data} {...props} />;
      default:
        return null;
    }
  };

  const _renderPagination = () => {
    if (type === 'icon' || type === 'media') {
      return <Paginate {...paginationProps} />;
    }
    return null;
  };

  return (
    <>
      <ChannelPage
        {...profileData}
        iscomment={iscomment}
        status={status}
        showcomment={showcomment}
        closecomment={closecomment}
        setShowComment={setShowComment}
        onSubmit={onSubmit}
        onVerify={onVerify}
        onTerminate={onTerminate}
        onDownload={onDownload}
        onNavItemClick={(key: string) => {
          setActiveNav(key);
        }}
      />
      {itemSpecData && <S.Container>{_renderBody()}</S.Container>}
      <PdfViewerModal
        {...(props || {})}
        showModal={pdfModalObj?.enableVisibility}
        title={pdfModalObj?.title}
        file={pdfModalObj?.src}
        onPdfClose={onPdfClose}
      />
      <VideoViewerModal
        {...(props || {})}
        videoSrc={videoModalObj?.src}
        showModal={videoModalObj?.enableVisibility}
        title={videoModalObj?.title}
        closeModal={onVideoClose}
      />
      <AudioViewerModal
        {...(props || {})}
        audioSrc={audioModalObj?.src}
        showModal={audioModalObj?.enableVisibility}
        title={audioModalObj?.title}
        closeModal={onAudioClose}
      />
      <ImageModal
        {...(props || {})}
        showModal={imageModalObj?.enableVisibility}
        title={imageModalObj?.title}
        imageSrc={imageModalObj?.src}
        onDeny={_onDeny}
      />
      <QRModal
        {...(props || {})}
        showModal={QRModalObj?.enableVisibility}
        closeModal={onQrClose}
        qrValue={QRModalObj?.qrValue}
      />
      {!profileData?.isDetail && (
        <ProfileComp
          {...profileData}
          {...submitData}
          iscomment={iscomment}
          status={status}
          showcomment={showcomment}
          closecomment={closecomment}
          setShowComment={setShowComment}
          onSubmit={onSubmit}
          onTerminate={onTerminate}
          onDownload={onDownload}
          onNavItemClick={(key: string) => {
            setActiveNav(key);
          }}
        />
      )}
    </>
  );
};

ItemSpecVenusWidget.defaultProps = {
  isLoading: false,
  type: 'icon',
};
